<script setup lang="ts">
import WarningToast from '@/widgets/warning-toast';

import { useHeader } from '../model/use-header';
import HeaderMenu from './menu.vue';
import RightPanel from './right-panel.vue';

const { spaId, menuLinks, visibleRightPanel, headerClasses } = useHeader();
</script>

<template>
  <div class="offset" />
  <warning-toast />

  <header :class="headerClasses">
    <div class="container">
      <nav class="flex-between text-sm bold">
        <header-menu :links="menuLinks" />
        <right-panel
          :links="visibleRightPanel"
          :spa-id="spaId"
        />
      </nav>
    </div>
  </header>
</template>

<style scoped lang="postcss">
.offset {
  height: 135px;
}

header {
  position: fixed;
  z-index: 3;
  margin-top: var(--common-menu-height);
  margin-bottom: var(--space-m-var_01);
  width: 100dvw;
  transition: opacity var(--duration) var(--timing-function);

  &.scrolled {
    top: 0;
    background-color: var(--color-deep-blue-85);
    opacity: 1;
  }

  nav {
    flex: 1 1;
    color: var(--color-white-100);
  }
}
</style>
